/**
 * Encodes a JavaScript value to a JSON string.
 * Supports optional indentation for pretty-printing.
 *
 * @param data - JavaScript value to encode
 * @param indent - Optional number of spaces for indentation (null for compact)
 * @returns JSON string representation
 *
 * @example
 * ```ts
 * import { JSONEncode } from "@pdfking/tfunc"
 *
 * const obj = { name: "John", age: 30 }
 * const compact = JSONEncode(obj)
 * // '{"name":"John","age":30}'
 *
 * const pretty = JSONEncode(obj, { indent: 2 })
 * // '{
 * //   "name": "John",
 * //   "age": 30
 * // }'
 * ```
 */
import { BigintQ } from "@pdfking/structs"
const defaults = { indent: null as number | null, bigint: false }

const replacer = (_: string, value: unknown) =>
  BigintQ(value) ? { __bigint__: `${value}` } : value

export const JSONEncode = (data: any, options: Partial<typeof defaults> = defaults) => {
  const opts = { ...defaults, ...options }
  return JSON.stringify(data, opts.bigint ? replacer : undefined, opts.indent ?? undefined)
}
